import { Action } from "@/api-schema-enums";
import { useAbility } from "@/casl-provider";
import { generateUuidV4Regex } from "@/common/helpers/utils";
import { ForbiddenView } from "@/views/common/forbidden.view";
import { NotFoundView } from "@/views/common/notfound.view";
import { CompanyGroupDetailView } from "@/views/company-group-detail/company-group-detail.view";
import { Route, Switch } from "wouter";
import { CompanyGroupView } from "./company-group.view";
import { CreateView } from "./create/create.view";
import { UpdateView } from "./update/update.view";

export function CompanyGroupRoutes() {
  const ability = useAbility();
  const companyGroupUpdateUuidRegex = generateUuidV4Regex({ paramName: "uuid", suffix: "/update" });
  const companyGroupDetailUuidRegex = generateUuidV4Regex({ paramName: "uuid" });
  const canManage = ability.can(Action.Manage, "CompanyGroup");

  return (
    <Switch>
      <Route path={"/"} component={CompanyGroupView} />
      <Route path={"/create"} component={canManage ? CreateView : ForbiddenView} />
      <Route path={companyGroupUpdateUuidRegex} component={canManage ? UpdateView : ForbiddenView} />
      <Route path={companyGroupDetailUuidRegex} component={CompanyGroupDetailView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
